// extracted by mini-css-extract-plugin
module.exports = {"main":"Buttons_main__bRT8_"};